module.exports = __webpack_public_path__ + "img/Puppet.dcd3a14.svg";